import axios from 'axios';

export const getEmailServerConfig = async () => {
    const { data } = await axios.get('/api/email/server-config');
    return data;
};

export const getEmailServerHealth = async () => {
    const { data } = await axios.get('/api/email/server-config/health');
    return data;
};

export const saveEmailServerConfig = async (payload) => {
    const { data } = await axios.post('/api/email/server-config', payload);
    return data;
};

export const getEmailTemplates = async () => {
    const { data } = await axios.get('/api/email/templates');
    return data;
};

export const createEmailTemplate = async (payload) => {
    const { data } = await axios.post('/api/email/templates', payload);
    return data;
};

export const updateEmailTemplate = async ({ id, ...payload }) => {
    if (!id) throw new Error('id is required');
    const { data } = await axios.patch(`/api/email/templates/${encodeURIComponent(id)}`, payload);
    return data;
};

export const deleteEmailTemplate = async (id) => {
    if (!id) throw new Error('id is required');
    const { data } = await axios.delete(`/api/email/templates/${encodeURIComponent(id)}`);
    return data;
};

export const previewEmailTemplate = async (payload) => {
    const { data } = await axios.post('/api/email/templates/preview', payload);
    return data;
};

export const sendTestEmail = async (payload) => {
    const { data } = await axios.post('/api/email/templates/test-send', payload);
    return data;
};

export const getEmailHelpers = async () => {
    const { data } = await axios.get('/api/email/helpers');
    return data;
};

export const saveEmailHelpers = async (payload) => {
    const { data } = await axios.post('/api/email/helpers', payload);
    return data;
};

export const previewEmailHelpers = async (payload) => {
    const { data } = await axios.post('/api/email/helpers/preview', payload);
    return data;
};

export const previewEmailHelpersContext = async (payload) => {
    const { data } = await axios.post('/api/email/helpers/preview-context', payload);
    return data;
};

export const getEmailFields = async ({ bac, programName }) => {
    const params = {};
    if (bac) params.bac = bac;
    if (programName) params.programName = programName;
    const { data } = await axios.get('/api/email/fields', { params });
    return data;
};

export const getEmailTriggers = async () => {
    const { data } = await axios.get('/api/email/triggers');
    return data;
};

export const getEmailTriggerSettings = async () => {
    const { data } = await axios.get('/api/email/triggers/settings');
    return data;
};

export const getEmailSendSettings = async () => {
    const { data } = await axios.get('/api/email/controls/settings');
    return data;
};

export const updateEmailSendSettings = async (payload) => {
    const { data } = await axios.post('/api/email/controls/settings', payload);
    return data;
};

export const setEmailSendingEnabled = async (enabled) => {
    const { data } = await axios.post('/api/email/controls/sending', { enabled });
    return data;
};

export const flushEmailQueue = async (payload = {}) => {
    const { data } = await axios.post('/api/email/controls/queue/flush', payload);
    return data;
};

export const getEmailSuppressions = async (options = {}) => {
    const params = {};
    if (options.includeExpired) params.includeExpired = true;
    const { data } = await axios.get('/api/email/suppressions', { params });
    return data;
};

export const createEmailSuppression = async (payload) => {
    const { data } = await axios.post('/api/email/suppressions', payload);
    return data;
};

export const updateEmailSuppression = async ({ id, ...payload }) => {
    if (!id) throw new Error('id is required');
    const { data } = await axios.patch(`/api/email/suppressions/${encodeURIComponent(id)}`, payload);
    return data;
};

export const deleteEmailSuppression = async (id) => {
    if (!id) throw new Error('id is required');
    const { data } = await axios.delete(`/api/email/suppressions/${encodeURIComponent(id)}`);
    return data;
};

export const getEmailTriggerLastRun = async () => {
    const { data } = await axios.get('/api/email/triggers/last-run');
    return data;
};

export const getEmailStatusTriggerSet = async () => {
    const { data } = await axios.get('/api/email/status-trigger-set');
    return data;
};

export const updateEmailStatusTriggerSet = async (payload) => {
    const { data } = await axios.patch('/api/email/status-trigger-set', payload);
    return data;
};

export const runEmailTriggersBackfill = async (payload = {}) => {
    const { data } = await axios.post('/api/email/triggers/backfill', payload);
    return data;
};

export const setEmailTriggerActive = async ({ id, enabled }) => {
    if (!id) throw new Error('id is required');
    const { data } = await axios.post(`/api/email/controls/triggers/${encodeURIComponent(id)}/active`, { enabled });
    return data;
};

export const getEmailTriggerSchema = async ({ bac, programName } = {}) => {
    const params = {};
    if (bac) params.bac = bac;
    if (programName) params.programName = programName;
    const { data } = await axios.get('/api/email/triggers/schema', { params });
    return data;
};

export const getEmailTriggerPresets = async () => {
    const { data } = await axios.get('/api/email/triggers/presets');
    return data;
};

export const explainEmailTrigger = async (payload) => {
    const { data } = await axios.post('/api/email/triggers/explain', payload);
    return data;
};

export const createEmailTrigger = async (payload) => {
    const { data } = await axios.post('/api/email/triggers', payload);
    return data;
};

export const updateEmailTrigger = async ({ id, ...payload }) => {
    if (!id) throw new Error('id is required');
    const { data } = await axios.patch(`/api/email/triggers/${encodeURIComponent(id)}`, payload);
    return data;
};

export const deleteEmailTrigger = async (id) => {
    if (!id) throw new Error('id is required');
    const { data } = await axios.delete(`/api/email/triggers/${encodeURIComponent(id)}`);
    return data;
};

export const testEmailTrigger = async (payload) => {
    const { data } = await axios.post('/api/email/triggers/test', payload);
    return data;
};

export const getEmailEnrollmentStatusValues = async () => {
    const { data } = await axios.get('/api/email/triggers/enrollment-status-values');
    return data;
};

export const testEmailTriggerBacStatus = async (payload) => {
    const { data } = await axios.post('/api/email/triggers/test-bac-status', payload);
    return data;
};

export const queryEmailTriggerSends = async (payload = {}) => {
    const { data } = await axios.post('/api/email/triggers/sends/query', payload);
    return data;
};

export const getEmailTriggerSendFilterKeys = async (options = {}) => {
    const params = {};
    if (options.start) params.start = options.start;
    if (options.end) params.end = options.end;
    if (options.days) params.days = options.days;
    const { data } = await axios.get('/api/email/triggers/sends/filter-keys', { params });
    return data;
};

export const getEmailTriggerSendById = async (id) => {
    if (!id) throw new Error('id is required');
    const { data } = await axios.get(`/api/email/triggers/sends/${encodeURIComponent(id)}`);
    return data;
};

export const deleteEmailTriggerSend = async (id) => {
    if (!id) throw new Error('id is required');
    const { data } = await axios.delete(`/api/email/triggers/sends/${encodeURIComponent(id)}`);
    return data;
};

export const retryEmailTriggerSend = async (id, options = {}) => {
    if (!id) throw new Error('id is required');
    const { data } = await axios.post(`/api/email/triggers/sends/${encodeURIComponent(id)}/retry`, options);
    return data;
};

export const refreshEmailTriggerSend = async (id) => {
    if (!id) throw new Error('id is required');
    const { data } = await axios.post(`/api/email/triggers/sends/${encodeURIComponent(id)}/refresh`);
    return data;
};

export const previewEventEmailOperation = async ({
    id,
    operation,
    eventFamily,
}) => {
    if (!id || !['retry', 'resend'].includes(operation)) {
        throw new Error('Valid event email operation is required');
    }
    const { data } = await axios.post(
        `/api/email/triggers/sends/${encodeURIComponent(id)}/event-${operation}/preview`,
        { eventFamily }
    );
    return data;
};

export const commitEventEmailOperation = async ({
    id,
    operation,
    idempotencyKey,
    ...payload
}) => {
    if (!id || !['retry', 'resend'].includes(operation)) {
        throw new Error('Valid event email operation is required');
    }
    const { data } = await axios.post(
        `/api/email/triggers/sends/${encodeURIComponent(id)}/event-${operation}`,
        payload,
        { headers: { 'Idempotency-Key': idempotencyKey } }
    );
    return data;
};

export const sendManualEmailTrigger = async (payload = {}) => {
    const { data } = await axios.post('/api/email/triggers/manual-send', payload);
    return data;
};
